import { DeclarationCohabitationFormVM } from 'mutation/view-models/declaration-cohabitation';
import { RequestAnprData, SubjectData } from 'shell/models/person';
interface RequestDeclarationCohabitation {
  richiesta5008: RequestAnprData;
  dati3002Dichiarante?: SubjectData;
  dati3002Convivente?: SubjectData;
}

export const transformerRequestDeclarationCohabitationData = (
  values: DeclarationCohabitationFormVM
): RequestDeclarationCohabitation => {
  return {
    dati3002Convivente: values?.convivente,
    dati3002Dichiarante: values?.dichiarante,
    richiesta5008: {
      generalitaPerRicerca: { ...(values?.dichiarante?.generalita || {}) },
      generalitaDaModificare: {
        generalita: { ...(values?.dichiarante?.generalita || {}) },
      },
      convivenzaDiFatto: {
        cittadinanza:
          !values?.cohabitant?.citizenship?.id || !values?.cohabitant?.citizenshipCode
            ? undefined
            : {
                codiceStato:
                  values?.cohabitant?.citizenshipCode || values?.cohabitant?.citizenship?.id,
                descrizioneStato: values?.cohabitant?.citizenship?.value,
                noteStato: values?.cohabitant?.noteCitizenship || undefined,
              },
        ordineConvivenza: values?.cohabitant?.orderCoexistence,
        convivente: values?.convivente?.generalita || null,
        contrattoStipula: {
          data: values?.cohabitationData?.requestDate?.toFormat('yyyy-MM-dd'),
          dataNotifica: values?.cohabitationData?.notifyDate?.toFormat('yyyy-MM-dd'),
          dataDocumento: values?.cohabitationData?.stipulationDate?.toFormat('yyyy-MM-dd'),
          protocollo: values?.cohabitationData?.notifyProtocol || undefined,
          documento: values.cohabitationData?.file?.raw || undefined,
          nomeFileAllegato: values.cohabitationData?.file?.name || undefined,
          professionista: values?.cohabitationData?.professionist || undefined,
          comuneRegistrazione: values?.cohabitationData?.municipality
            ? {
                nomeComune: values?.cohabitationData?.municipality?.description,
                codiceIstat: values?.cohabitationData?.municipality?.id,
                siglaProvinciaIstat: values?.cohabitationData?.municipality?.province,
              }
            : undefined,
        },
      },
      datiControllo: {
        gestioneCF: values?.editDataControl?.flag,
        tipoMutazione: ['16'],
      },
      testataRichiesta: {
        dataDecorrenza: values?.editDataControl?.dateValidity?.toFormat('yyyy-MM-dd'),
      },
    },
  };
};
